import React, { useState } from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Box,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import TitleBar from "../../../components/TitleBar";
import TripPort from "../../../components/TripPort";
import BlockDate from "../../../components/BlockDatePicker/BlockDatePicker";

const OpenBlockForm = ({ values, errors, onChange, onSubmit, onCancel }) => {
  const [toggleBlockType, setToggleBlockType] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const spawningMessge = "Spawning blocks have a 20 day duration.";
  const gillnetMessage = "Gillnet blocks must be at least 7 days in duration.";
  let endDateHelpText =
    values.blockType === "SPAWNING" ? spawningMessge : gillnetMessage;

  return (
    <>
      <TitleBar title="DAS Open Block" />
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <FormControl variant="standard" component="fieldset">
          <RadioGroup
            name="block_type"
            id="block_type"
            value={values.blockType}
            onChange={onChange("block_type")}
          >
            <FormControlLabel
              value="SPAWNING"
              control={<Radio color="primary" />}
              label="20-Day Spawning Block"
              onChange={() => setToggleBlockType(true)}
            />
            <FormControlLabel
              value="GILLNET"
              control={<Radio color="primary" />}
              label="120-Day Block for Day Gillnet Vessels"
              onChange={() => setToggleBlockType(false)}
            />
          </RadioGroup>
        </FormControl>
      </Box>

      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <TripPort
          id="port"
          name="port"
          label="Arrival Ports"
          value={values.portcd}
          onChange={onChange("port")}
        />
      </Box>
      {errors.port && <Alert severity="error">{errors.port}</Alert>}

      <Box display="flex" justifyContent="center" bgcolor="background.paper">
        <Box p={1}>
          <BlockDate
            aDate={values.startDate}
            name="start_date"
            label={"Block Start Date"}
            message={"Choose a date."}
            onChange={onChange}
          />
        </Box>
      </Box>
      {errors.startDate && <Alert severity="error">{errors.startDate}</Alert>}

      <Box display="flex" justifyContent="center" bgcolor="background.paper">
        <Box p={1}>
          <BlockDate
            aDate={values.endDate}
            name="end_date"
            label={"Block End Date"}
            message={endDateHelpText}
            onChange={onChange}
            toggler={toggleBlockType}
          />
        </Box>
      </Box>
      {errors.endDate && <Alert severity="error">{errors.endDate}</Alert>}

      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={onCancel}>
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button
            variant="contained"
            className={isDisabled ? "disabledBtn" : "successBtn"}
            onClick={(event) => {
              setIsDisabled(true);
              onSubmit(event);
            }}
            disabled={isDisabled}
          >
            Confirm
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default OpenBlockForm;
